import React from 'react'
import { Route, useRouteMatch } from 'react-router'
import { positionDefault } from '@reach/popover'
import { NavbarFilterProps } from 'components/Navbar'
import { SelectInput, SelectTriggerUnstyled } from 'components/Select'
import {
  useGetDocumentListSettingsQuery,
  WorkspaceMinimalFragment,
} from 'gqlTypes'
import {
  Filter,
  IconWrapper,
  StyledCheckbox,
  StyledChevron,
  StyledSelectPopover,
  ToggleWrapper,
  StyledDropdownItem,
  TooltipShortcut,
} from './SearchBar.styles'
import Dropdown from 'components/Dropdown'
import Tooltip from 'components/Tooltip'
import { routes } from 'constants/routes'

export interface SearchBarProps {
  onSearchChange?: NonNullable<NavbarFilterProps['onChange']>
  search?: NavbarFilterProps['value']
  userRole: WorkspaceMinimalFragment['userRole']
}

const getPlaceholderByPath = (path: string) => {
  switch (path) {
    case routes.WORKSPACE_TRASH.template():
      return 'Search trash'
    case routes.WORKSPACE_LIBRARIES.template():
      return 'Search libraries'
    case routes.WORKSPACE_SHARED_WITH_ME.template():
      return 'Search shared with me'
    case routes.WORKSPACE_DRAFTS.template():
      return 'Search my drafts'
    default:
      return 'Search'
  }
}

export const SearchBar = ({
  onSearchChange,
  search,
  userRole,
}: SearchBarProps) => {
  const { data, updateQuery } = useGetDocumentListSettingsQuery()
  const { showDocumentsInProjects } = data || {}

  const shouldShowSearchOptions = userRole !== 'GUEST'

  const { path } = useRouteMatch()
  const inputPlaceholder = getPlaceholderByPath(path)

  return (
    <Tooltip
      content={
        <>
          Search
          <TooltipShortcut>Press /</TooltipShortcut>
        </>
      }
      placement="bottom-start">
      <Filter
        onChange={onSearchChange}
        value={search}
        name="search"
        placeholder={inputPlaceholder}>
        <Route path={routes.WORKSPACE_SHARES.template()}>
          {shouldShowSearchOptions && (
            <SelectInput value={'Options'}>
              <SelectTriggerUnstyled>
                <ToggleWrapper>
                  Options
                  <IconWrapper>
                    <StyledChevron />
                  </IconWrapper>
                </ToggleWrapper>
              </SelectTriggerUnstyled>
              <StyledSelectPopover position={positionDefault}>
                <Dropdown.Header>Show Documents</Dropdown.Header>
                <StyledDropdownItem>
                  <StyledCheckbox
                    checked={showDocumentsInProjects}
                    label="Include documents in Projects"
                    onChange={event =>
                      updateQuery(previous => ({
                        ...previous,
                        showDocumentsInProjects: !showDocumentsInProjects,
                      }))
                    }
                  />
                </StyledDropdownItem>
                {/* Reset is hidden for now until we don't have more search options to reset */}
                {/* <Dropdown.Divider />
            <StyledDropdownResetItem
              disabled={includeDocsInProjects === true}
              onClick={() => onIncludeDocsInProjectsChange(true)}>
              <StyledResetIcon disabled={includeDocsInProjects === true} />{' '}
              Reset
            </StyledDropdownResetItem> */}
              </StyledSelectPopover>
            </SelectInput>
          )}
        </Route>
      </Filter>
    </Tooltip>
  )
}
